<template>
  <v-data-table
    :style="{ borderRadius: 0 }"
    hide-default-footer
    hide-default-header
    :show-select="false"
    :headers="columns"
    :expanded.sync="expanded"
    :items="items"
  >
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length + 2" :style="{ padding: 0 }">
        <NestedTable
          :depth="depth + 1"
          @setActive="handlerRow"
          :items="item.nested.map(i => i.object2)"
          :columns="columns"
        />
      </td>
    </template>
    <template v-slot:header.muted>
      <v-icon>mdi-volume-off</v-icon>
    </template>
    <template v-slot:header.deviceBatteryLevel>
      <v-icon>mdi-battery</v-icon>
    </template>
    <template v-slot:header.favourite>
      <v-icon color="#FFD600">mdi-star</v-icon>
    </template>
    <template v-slot:header.deviceResponseStatus>
      <v-icon>mdi-cloud-outline</v-icon>
    </template>
    <template v-slot:header.deviceEmulation>
      <v-icon>mdi-blur</v-icon>
    </template>
    <template v-slot:item="{ item, index, isSelected }">
      <tr
        :data-test="`entityRowNeste_${index}`"
        :data-test-name="item.login"
        @click="handlerRow(item)"
        :class="$route.params.id === item.id || isSelected ? 'active-row' : ''"
      >
        <td
          v-for="(itemNested, index) in columns"
          class="nestedCell"
          :width="itemNested.width"
          :style="{
            'min-width': itemNested.width
          }"
          :key="index"
        >
          <template v-if="itemNested.value === 'data-table-select'">
            <avatar-item v-show="false" style="margin: 0 auto;" :item="item" />
          </template>
          <template v-if="itemNested.value === 'deviceResponseStatus'">
            <v-icon v-if="item.deviceResponseStatus">mdi-cloud-outline</v-icon>
            <v-icon v-else color="red">mdi-cloud-off-outline</v-icon>
          </template>
          <template v-else-if="itemNested.value === 'deviceBatteryLevel'">
            <battery-state :object="item" size="24px" />
          </template>
          <template v-else-if="itemNested.value === 'status'">
            <span v-if="item.status">Enabled</span>
            <span v-else>Disabled</span>
          </template>
          <template v-else-if="itemNested.value === 'login'">
            <span :data-test-table-item="item.login">{{ item.login }}</span>
          </template>
          <template v-else-if="itemNested.value === 'drivername'">
            <span :data-test-table-schema-name="item.drivername">{{
              item.schemaName
            }}</span>
          </template>
          <template v-else-if="itemNested.value === 'online'">
            <div></div>
          </template>
          <template v-else-if="itemNested.value === 'enabled'">
            <span data-test-table-item-enabled="Enabled" v-if="item.enabled"
              >Enabled</span
            >
            <span data-test-table-item-enabled="Disabled" v-else>Disabled</span>
          </template>
          <template v-else-if="itemNested.value === 'name'">
            <div
              class="nameColumn"
              :data-test-table-item="item.name"
              :style="{ paddingLeft: `${20 * depth}px` }"
            >
              <!--              <div class="nestedIndicator"></div>-->
              {{ truncateString(item.name, 50) }}
            </div>
          </template>
          <template v-else-if="itemNested.value === 'objectName'">
            <span :data-test-table-item="item.objectName">{{
              truncateString(item.objectName, 50)
            }}</span>
          </template>
          <template v-else-if="itemNested.value === 'message'">
            <span :data-test-table-item-message="item.message">{{
              truncateString(item.message, 50)
            }}</span>
          </template>
          <template v-else-if="itemNested.value === 'favourite'">
            <span :data-test-table-item-favourite="item.favourite">
              <v-icon color="#FFD600" v-if="item.favourite">mdi-star</v-icon>
            </span>
          </template>
          <template v-else-if="itemNested.value === 'muted'">
            <span>
              <v-icon :data-test-table-item-muted="item.muted" v-if="item.muted"
                >mdi-volume-off</v-icon
              >
            </span>
          </template>
          <template v-else-if="itemNested.value === 'deviceEmulation'">
            <v-icon v-if="item.deviceEmulation">mdi-blur</v-icon>
          </template>
          <template v-else-if="itemNested.value === 'lastExecutionResult'">
            <template v-if="!item.lastExecutionResult">
              "n/a"
            </template>
            <template v-else-if="item.lastExecutionResult.id === 'BROKEN'">
              <span style="color: #D50000">
                {{ item.lastExecutionResult.title }}
              </span>
            </template>
            <template v-else>
              {{ item.lastExecutionResult.title }}
            </template>
          </template>
          <template v-else-if="itemNested.value === 'tags'">
            <v-chip
              small
              color="primary"
              class="mr-2"
              v-for="chip in item.tags"
              :key="chip"
            >
              {{ chip }}
            </v-chip>
          </template>
          <template v-else>
            {{ item[itemNested.value] }}
          </template>
        </td>
        <td
          width="100%"
          class="nestedCell"
          :style="{ 'min-width': '100%' }"
        ></td>
        <!--        <td width="1px" class="nestedCell" :style="{ 'min-width': '1px' }"></td>-->
        <td class="nestedCell">
          <template v-if="item.nested && item.nested.length > 0">
            <v-btn icon @click.stop.prevent="expandItem(item)">
              <v-icon v-if="expanded.find(i => i.id === item.id)"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
import AvatarItem from '@/components/appTable/avatarItem.vue';
import BatteryState from '@/components/device-states/BatteryState.vue';
import { truncateString } from '../../utils/truncate';

export default {
  name: 'NestedTable',
  props: {
    columns: {
      type: [Array],
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    items: {
      type: [Array],
      required: true
    }
  },
  components: {
    AvatarItem,
    BatteryState
  },
  data() {
    return {
      expanded: []
    };
  },
  methods: {
    truncateString,
    expandItem(item) {
      console.log(item);
      if (this.expanded.map(i => i.id).includes(item.id)) {
        this.expanded = this.expanded.filter(i => i.id !== item.id);
      } else {
        this.expanded.push(item);
      }
    },
    handlerRow(e) {
      this.$emit('setActive', e);
    }
  }
};
</script>

<style lang="scss">
.nameColumn {
  position: relative;
}

.nestedIndicator {
  border-left: 1px dotted gray;
  width: 40px;
  height: 29px;
  position: absolute;
  top: 39px;

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 14px;
    bottom: 0;
    border-bottom: 1px dotted gray;
  }
}
</style>
